import React from "react";
import { Modal } from "react-bootstrap";
import SkeletonLoader from "components/ui/SkeletonLoader";
import { AlertTriangle, Clock, Users, XCircle, X } from "lucide-react";
import "./Closejobmodal.css";

interface CloseJobModalProps {
  show: boolean;
  jobTitle?: string;
  isClosing: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const CloseJobModal: React.FC<CloseJobModalProps> = ({
  show,
  jobTitle,
  isClosing,
  onCancel,
  onConfirm,
}) => (
  <Modal
    show={show}
    onHide={() => !isClosing && onCancel()}
    centered
    contentClassName="cj-content"
    backdropClassName="cj-backdrop"
  >
    <button
      type="button"
      className="cj-close"
      onClick={onCancel}
      disabled={isClosing}
      aria-label="Close"
    >
      <X size={18} />
    </button>

    <Modal.Body className="cj-body">
      <div className="cj-icon">
        <AlertTriangle size={26} />
      </div>

      <h2 className="cj-title">Close Position</h2>
      <p className="cj-text">
        Are you sure you want to close <strong>"{jobTitle || "this job"}"</strong>? This will
        stop accepting new applications.
      </p>

      <div className="cj-notice">
        <div className="cj-notice-head">
          <AlertTriangle size={15} />
          Active candidates will be affected
        </div>
        <ul className="cj-notice-list">
          <li className="cj-notice-item">
            <Clock size={15} />
            <span>Applicants will no longer be able to apply once this position is closed.</span>
          </li>
          <li className="cj-notice-item">
            <Users size={15} />
            <span>Existing candidate records and interview progress will remain available.</span>
          </li>
        </ul>
      </div>

      <div className="cj-actions">
        <button
          type="button"
          className="cj-btn cj-btn-cancel"
          onClick={onCancel}
          disabled={isClosing}
        >
          Keep Open
        </button>
        <button
          type="button"
          className="cj-btn cj-btn-danger"
          onClick={onConfirm}
          disabled={isClosing}
        >
          {isClosing ? (
            <>
              <SkeletonLoader inline width={14} height={14} style={{ borderRadius: 4, marginRight: 6 }} />
              Closing...
            </>
          ) : (
            <>
              <XCircle size={16} />
              Close Position
            </>
          )}
        </button>
      </div>
    </Modal.Body>
  </Modal>
);

export default CloseJobModal;

/* ---------- Usage: replace your <Modal show={!!jobToClose} ...> block with ----------

<CloseJobModal
  show={!!jobToClose}
  jobTitle={jobToClose?.title}
  isClosing={isClosing}
  onCancel={() => setJobToClose(null)}
  onConfirm={handleConfirmClose}
/>
*/